@if (player.id && is_loaded) {
    @if (shouldShowTabs) {
        <app-tab-group (tabChanged)="tabChanged($event)">
            @for (tab of tabs; track tab) {
                <app-tab>
                    <app-tab-label>
                        {{ appStringAPI.getAppString(tab.label) }}
                    </app-tab-label>
                    <app-tab-content>
                        <app-sponsor-banner [location]="'player-details-top'" [sponsor_key]="'player-details-top'" [aspect_ratio]="'9:1'" style="margin-top: 10px">
                        </app-sponsor-banner>
                        <!-- STATS TAB CONTENT -->
                        @if (tab.type === 'stats') {
                            <div class="section-header">
                                {{ appStringAPI.getAppString('golf.players.details.label') }}
                            </div>
                            <section class="details-container">
                                @for (item of details_keys; track item) {
                                    <div class="row">
                                        {{ appStringAPI.getAppString(item.key) }}
                                        <div class="stat">{{ getDetail(item.value) }}</div>
                                    </div>
                                }
                            </section>
                            @if (hasRankings) {
                                <div class="section-header">
                                    {{ appStringAPI.getAppString('golf.players.tabs.rankings.title') }}
                                </div>
                                <section class="ranking-blocks">
                                    @for (item of rankings_details_keys | keyvalue: asIsOrder; track $index) {
                                        @if (getRanking(item.key)) {
                                            <div class="rank-block">
                                                <div class="section-header">
                                                    {{ appStringAPI.getAppString(anyValueToString(item?.value?.title)) }}
                                                </div>
                                                <section class="details-container">
                                                    @for (ranking of getRankingItems(item.value.items); track $index) {
                                                        <div>
                                                            <span>{{ appStringAPI.getAppString(ranking.key) }}</span>
                                                            <div class="stat">{{ getRankingValue(ranking) }}</div>
                                                        </div>
                                                    }
                                                </section>
                                            </div>
                                        }
                                    }
                                </section>
                            }
                        }
                        <!-- NEWS TAB CONTENT -->
                        @if (tab.type === 'news') {
                            @if (articles.length > 0) {
                                <div class="details-section">
                                    <section class="articles scroll-section" (scroll)="onNewsScroll($event)">
                                        <div>
                                            @for (article of articles; track article; let i = $index) {
                                                <div class="article-container" (click)="openLink(article)">
                                                    <app-image
                                                        [image_url]="article.image_url"
                                                        [width]="'100%'"
                                                        [height]="'100%'"
                                                        [border_radius]="'4px'"
                                                        [type]="handleType(article.type)"
                                                    >
                                                    </app-image>
                                                    <div class="article-content">
                                                        <div class="article-title">{{ article.title }}</div>
                                                        <time class="article-date">{{ article.publication_date | date: 'mediumDate' }}</time>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </section>
                                </div>
                            }
                        }
                    </app-tab-content>
                </app-tab>
            }
        </app-tab-group>
    } @else {
        <app-sponsor-banner [location]="'player-details-top'" [sponsor_key]="'player-details-top'" [aspect_ratio]="'9:1'" style="margin-top: 10px"> </app-sponsor-banner>
        <div class="section-header">
            {{ appStringAPI.getAppString('golf.players.details.label') }}
        </div>
        <section class="details-container">
            @for (item of details_keys; track item) {
                <div class="row">
                    {{ appStringAPI.getAppString(item.key) }}
                    <div class="stat">{{ getDetail(item.value) }}</div>
                </div>
            }
        </section>
        @if (hasRankings) {
            <div class="section-header">
                {{ appStringAPI.getAppString('golf.players.tabs.rankings.title') }}
            </div>
            <section class="ranking-blocks">
                @for (item of rankings_details_keys | keyvalue: asIsOrder; track $index) {
                    @if (getRanking(item.key)) {
                        <div class="rank-block">
                            <div class="section-header">
                                {{ appStringAPI.getAppString(anyValueToString(item?.value?.title)) }}
                            </div>
                            <section class="details-container">
                                @for (ranking of getRankingItems(item.value.items); track $index) {
                                    <div>
                                        <span>{{ appStringAPI.getAppString(ranking.key) }}</span>
                                        <div class="stat">{{ getRankingValue(ranking) }}</div>
                                    </div>
                                }
                            </section>
                        </div>
                    }
                }
            </section>
        }
    }
    <!-- SINGLE TAB MODE: stats only, no tabs -->
}
